export default "__VITE_ASSET__CnEyfOca__"